import { MacroDropDownComponent } from './macro-drop-down/macro-drop-down.component';
// import { HighlightService } from '../../@core/services/highlight.service';
import { ConfigOption } from '@ngx-formly/core';

export const MACRO_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-macro-drop-down', component: MacroDropDownComponent, wrappers: ['simple-title'] },
]
